import { render, staticRenderFns } from "./CustomerAppLayout.vue?vue&type=template&id=131aed3f&scoped=true&"
import script from "./CustomerAppLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerAppLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAppLayout.vue?vue&type=style&index=0&id=131aed3f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131aed3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
